module.exports = __webpack_public_path__ + "assets/table.138da416.svg";